import {
    UPDATE_PANEL_PROPERTIES,
    HIDE_PRIMARY_PANEL,
    SHOW_PRIMARY_PANEL,
    TOGGLE_PRIMARY_PANEL_COMPACT,
    HIDE_SECONDARY_PANEL,
    SHOW_SECONDARY_PANEL,
    TOGGLE_SECONDARY_PANEL_COMPACT
} from './Types';

import defaultPanels from './Constants';
import * as PanelNames from '../../Components/CartoLib/Panels/PanelNames';

import { IPanelReducerState, IPanelAction, IPanelNameAction } from './panelTypes';

function setPanelProperties(state: IPanelReducerState, action: IPanelNameAction) {
    const panels = { ...state.panels };
    const panel = panels[action.name];
    const updatedPanel = {
        ...panel,
        ...action.properties
    };
    panels[action.name] = updatedPanel;
    return panels;
}

function showPrimaryPanel(state: IPanelReducerState, action: IPanelNameAction) {
    const panels = { ...state.panels };
    if (state.secondaryPanel) {
        panels[state.secondaryPanel].compact = true;
    }
    if (state.primaryPanel) {
        panels[state.primaryPanel].enabled = false;
        panels[state.primaryPanel].compact = true;
    }
    panels[action.name].enabled = true;
    panels[action.name].compact = false;
    return {
        ...state,
        panels: panels,
        primaryPanel: action.name
    };
}

function hidePrimaryPanel(state: IPanelReducerState, action: IPanelAction) {
    const panels = { ...state.panels };
    if (state.primaryPanel) {
        panels[state.primaryPanel].enabled = false;
        panels[state.primaryPanel].compact = true;
    }
    return {
        ...state,
        panels: panels,
        primaryPanel: null
    };
}

function togglePrimaryPanelCompact(state: IPanelReducerState, action: IPanelAction) {
    const panels = { ...state.panels };
    if (state.primaryPanel) {
        if (panels[state.primaryPanel].compact) {
            panels[state.primaryPanel].compact = false;
            if (state.secondaryPanel) {
                panels[state.secondaryPanel].compact = true;
            }
        } else {
            panels[state.primaryPanel].compact = true;
        }
    }
    return {
        ...state,
        panels: panels
    };
}

function showSecondaryPanel(state: IPanelReducerState, action: IPanelNameAction) {
    const panels = { ...state.panels };
    if (state.primaryPanel) {
        panels[state.primaryPanel].compact = true;
    }
    if (state.secondaryPanel) {
        panels[state.secondaryPanel].enabled = false;
        panels[state.secondaryPanel].compact = true;
    }
    panels[action.name].enabled = true;
    panels[action.name].compact = false;
    return {
        ...state,
        panels: panels,
        secondaryPanel: action.name
    };
}

function hideSecondaryPanel(state: IPanelReducerState, action: IPanelAction) {
    const panels = { ...state.panels };
    if (state.secondaryPanel) {
        panels[state.secondaryPanel].enabled = false;
        panels[state.secondaryPanel].compact = true;
    }
    return {
        ...state,
        panels: panels,
        secondaryPanel: null
    };
}

function toggleSecondaryPanelCompact(state: IPanelReducerState, action: IPanelAction) {
    const panels = { ...state.panels };
    if (state.secondaryPanel) {
        if (panels[state.secondaryPanel].compact) {
            panels[state.secondaryPanel].compact = false;
            if (state.primaryPanel) {
                panels[state.primaryPanel].compact = true;
            }
        } else {
            panels[state.secondaryPanel].compact = true;
        }
    }
    return {
        ...state,
        panels: panels
    };
}

const defaultState = {
    ...showSecondaryPanel(
        {
            panels: defaultPanels,
            primaryPanel: null,
            secondaryPanel: null
        },
        {
            name: PanelNames.dataLayers
        }
    )
};

export default function reducer(state: IPanelReducerState = defaultState, action: IPanelAction) {
    switch (action.type) {
        case UPDATE_PANEL_PROPERTIES:
            return setPanelProperties(state, action as IPanelNameAction);
        case HIDE_PRIMARY_PANEL:
            return hidePrimaryPanel(state, action);
        case SHOW_PRIMARY_PANEL:
            return showPrimaryPanel(state, action as IPanelNameAction);
        case TOGGLE_PRIMARY_PANEL_COMPACT:
            return togglePrimaryPanelCompact(state, action);
        case HIDE_SECONDARY_PANEL:
            return hideSecondaryPanel(state, action);
        case SHOW_SECONDARY_PANEL:
            return showSecondaryPanel(state, action as IPanelNameAction);
        case TOGGLE_SECONDARY_PANEL_COMPACT:
            return toggleSecondaryPanelCompact(state, action);
        default:
            return state;
    }
}
